export default class ZoomBlocker {
  constructor(mapboxmap, main) {
    this._ = main;
    this.map = mapboxmap;
    this.map.scrollZoom.disable();

    const { mapSettings } = this._.settings.getSettings();
    this.mapSettings = mapSettings;

    mapboxmap.on("wheel", (event) => {
      const originalEvent = event.originalEvent;
      if (originalEvent.ctrlKey || originalEvent.metaKey) {
        const rect = mapboxmap.getCanvas().getBoundingClientRect();
        const point = [
          originalEvent.clientX - rect.left,
          originalEvent.clientY - rect.top,
        ];
        const zoomDelta = -originalEvent.deltaY * 0.002;

        event.preventDefault();
        mapboxmap.zoomTo(mapboxmap.getZoom() + zoomDelta, {
          around: mapboxmap.unproject(point),
          duration: 0,
        });
        return;
      }

      event.preventDefault();
      this.showBlockAlert();
    });

    this.createScrollZoomBlocker();
  }

  showBlockAlert() {
    if (this.msgContainer.style.visibility === "hidden")
      this.msgContainer.style.visibility = "visible";
    this.msgContainer.classList.add("active");

    clearTimeout(this.time);

    this.time = setTimeout(() => {
      this.msgContainer.classList.remove("active");
    }, 200);

    this._.map.events.mouseleave();
    this._.map.events.addRemoveMapEvents({ remove: true });
    setTimeout(() => {
      this._.map.events.addRemoveMapEvents({ add: true });
    }, 2000);
  }

  createScrollZoomBlocker() {
    if (this.map) {
      const div = document.createElement("div");
      div.classList.add("mapboxgl-zoom-blocker");
      this._.el.appendChild(div);
      this.msgContainer = div;

      if (/(Mac|iPad)/i.test(window.navigator.userAgent)) {
        this.msgContainer.textContent = this.mapSettings.msgContainerMac;
      } else {
        this.msgContainer.textContent = this.mapSettings.msgContainerWin;
      }
    }
  }
}
